import type { String } from "@pdfking/tfunc"

export type ColorID = String<"ColorID">
